import { createGlobalStyle } from "styled-components";
import "react-toastify/dist/ReactToastify.css";

export default createGlobalStyle`
    :root {
        --form-black: #232323;
        --form-left: #e6ecf0;
        --register-gray: #727272;
        --header-white: rgb(243, 243, 243);
        --black: #000;
        --green: #59C15D;
        --red: #E02041;
        --orange: #e65400;
        --yellow: #ffba01;
        --blue: #086BAB;
        --blue-mustang: #032156;
        --blue-icon: #0184ff;
        --light-blue: #5989C1;
        --light-white: #FAFAFA;
        --light-fake-blue: #6fc2d1;
        --light-gray: #D3D3D3;
        --dark-gray: #778899;
        --dark-green: #08ab11;

    }

    input, textarea, select {
      display: block;
      width: 80%;
      height: calc(1.6em + 0.75rem + 2px);
      padding: 0.375rem 0.75rem;
      font-size: 0.9rem;
      font-weight: 400;
      line-height: 1.6;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    input:disabled {
      background-color: var(--light-gray);
    }

    input[type="radio"], input[type="checkbox"] {
      height: 1rem;
      width: auto;
    }

    input[type="date"], input[type="number"], input[type="time"], input[type="float"] {
      width: auto;
    }

    input[type="date"] {
      color: #495057;
      box-shadow: none;
    }
`;
